import * as yup from "yup";
import moment from "moment";

const personalDetailsSchema = yup.object().shape({
  gender: yup.string().when("owner_type", {
    is: "IND",
    then: yup.string().required(),
  }),
  owner_type: yup.string(),
  is_married: yup.string().when("owner_type", {
    is: "IND",
    then: yup.string().required(),
  }),
  is_pa: yup.boolean(),
  nominee_name: yup.string().when("owner_type", {
    is: "IND",
    then: yup.string().required("Nominee Name is required"),
  }),
  nominee_age: yup.string().when("owner_type", {
    is: "IND",
    then: yup.string().required("Age is required"),
  }),
  nominee_dob: yup
    .string()
    .nullable()
    .required("Nominee's Date of Birth is required")
    .test("valid-date", "Please enter a valid date", (val) =>
      moment(val, "YYYY-MM-DD", true).isValid()
    )
    .when("nominee_relation", {
      is: (relation) =>
        relation !== "Son" &&
        relation !== "Daughter" &&
        relation !== "Mother" &&
        relation !== "Father",
      then: (schema) =>
        schema.test(
          "age-check",
          "Nominee's Age should be more than 18 years",
          (val) => moment().diff(moment(val), "years") >= 18
        ),
      otherwise: (schema) =>
        schema.test(
          "relation-age-check",
          "Invalid age based on relation",
          function (val) {
            const parentDob = this.parent.dob;
            if (!parentDob || !val) return true;

            const nomineeRelation = this.parent.nominee_relation;
            const nomineeMoment = moment(val);
            const parentMoment = moment(parentDob);

            if (nomineeRelation === "Son" || nomineeRelation === "Daughter") {
              // Child must be born after parent
              return nomineeMoment.isAfter(parentMoment);
            }
            if (nomineeRelation === "Mother" || nomineeRelation === "Father") {
              // Parent must be at least 18 years older
              return parentMoment.diff(nomineeMoment, "years") >= 18;
            }
            return true;
          }
        ),
    }),
  nominee_relation: yup.string().when("owner_type", {
    is: "IND",
    then: yup.string().required("Nominee Relation is required"),
  }),
  dob: yup.string().when("owner_type", {
    is: "IND",
    then: yup.string().required("Date of Birth is required"),
  }),
  company_slug: yup.string().required(),
  occupation: yup.string().when("owner_type", {
    is: "IND",
    then: yup.string().required(),
  }),
});

export default personalDetailsSchema;
